// Action Types
const SET_THEME = '@@app/theme/SET_THEME';
const SET_NAV_TYPE = '@@app/theme/SET_NAV_TYPE';
const SET_NAV_MAIN = '@@app/theme/SET_NAV_MAIN';
const SET_NAV_CHILDREN = '@@app/theme/SET_NAV_CHILDREN';

// Initial State
const initialState = {
  base: 'theme-base-weekly',
  slug: 'theme-weekly',
  navType: 'plain',
  navMain: [],
  navChildren: [],
};

const mainItems = {
  nutrition: {
    title: 'Nutrition',
    icon: 'fa fa-lg icon-recipes',
    path: 'nutrition',
    upgrade: false,
  },

  workouts: {
    title: 'Workouts',
    icon: 'fa fa-lg icon-workouts',
    path: 'workouts',
    upgrade: false,
  },

  favourites: {
    title: 'Favourites',
    icon: 'fa fa-lg icon-favourites',
    path: 'favourites',
    upgrade: false,
  },
};

const childItems = {
  nutrition: [
    {
      title: 'Recipes',
      path: 'nutrition.recipes',
    },
    {
      title: 'Meal Plans',
      path: 'nutrition.mealPlans',
    },
    {
      title: 'Hacks',
      path: 'nutrition.hacks',
    },
  ],

  workouts: [
    {
      title: 'Videos',
      path: 'workouts.videos',
    },
    {
      title: 'Express',
      path: 'workouts.express',
    },
    {
      title: 'Hacks',
      path: 'workouts.hacks',
    },
  ],

  favourites: [
    {
      title: 'Recipes',
      subscriptionTitle: 'Voome Nutrition',
      path: 'favourites.recipes',
    },
    {
      title: 'Workouts',
      subscriptionTitle: 'Voome Workouts',
      path: 'favourites.workouts',
    },
    {
      title: 'Videos',
      subscriptionTitle: 'Voome Workouts',
      path: 'favourites.videos',
    },
  ],
};

// Actions
export const setTheme = (isWeekly, slug, status) => {
  const isWorkout = slug.includes('workout');
  const isNutrition = slug.includes('nutrition');

  const nutrition = {
    ...mainItems.nutrition,
    upgrade: isWorkout,
  };

  const workouts = {
    ...mainItems.workouts,
    upgrade: isNutrition,
  };

  const favourites = {
    ...mainItems.favourites,
    childPath: isWorkout ? 'favourites.workouts' : 'favourites.recipes',
  };

  return {
    type: SET_THEME,
    payload: {
      base: `theme-base-${isWeekly ? 'weekly' : 'program'}`,
      slug: `theme-${isWeekly ? 'weekly' : slug}`,
      navMain:
        isWeekly && !/cancelled|suspended/.test(status)
          ? isWorkout
            ? [workouts, nutrition, favourites]
            : [nutrition, workouts, favourites]
          : [],
    },
  };
};

export const setNavType = navType => {
  return { type: SET_NAV_TYPE, payload: { navType } };
};

export const setNavChildren = (key, subscriptionTitle = '') => {
  const items = childItems[key] || [];

  const navChildren = /Workouts|Nutrition/.test(subscriptionTitle)
    ? items.filter(item => item.subscriptionTitle === subscriptionTitle)
    : items;

  return {
    type: SET_NAV_CHILDREN,
    payload: { navChildren },
  };
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_THEME:
      return {
        ...state,
        base: payload.base,
        slug: payload.slug,
        navMain: payload.navMain,
      };

    case SET_NAV_TYPE:
      return {
        ...state,
        navType: payload.navType,
      };

    case SET_NAV_CHILDREN:
      return {
        ...state,
        navChildren: payload.navChildren,
      };

    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/logic/theme.js